/**
 * The browser's wall clock, in one function.
 *
 * `eslint.config.js` bans `new Date()` and `Date.now()` everywhere except
 * `packages/shared/src/dates.ts` and `integrations/clock*.ts`, and this file is
 * the second of those for the SPA. The rule is not ceremony here: the resend
 * countdown on `/login` and every relative date on a page have to be movable in a
 * test, and a `new Date()` sprinkled through components is a suite that can only be
 * written with global fake timers.
 *
 * There is no `Clock` interface and no fake. `ARCHITECTURE.md` §Integrations — "one
 * implementation plus one fake is the rule; a third waits until it exists" — and in
 * a browser there is exactly one clock. A test moves it with
 * `vi.setSystemTime(…)`, which is the same instrument for every caller.
 */

/** Now, as the browser sees it. */
export function now(): Date {
  return new Date()
}
